import React, { useEffect, useState } from 'react';
import './moneyInput.scss';

interface MoneyInputProps {
	setValue: any;
	name: string;
	value: any;
}

const MoneyInput = (props: MoneyInputProps) => {
	const { setValue, name, value } = props;
	const [number, setNumber] = useState('');
	const [maskedValue, setMaskedValue] = useState(value || value === 0 ? createMask(value + '') : '$');

	function createMask(value: string) {
		return '$ ' + value.replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,');
	}

	function destroyMask(value: string) {
		return value.replace(/\D/g, '');
	}

	const handleChange = (e: any) => {
		let value: string | number = destroyMask(e.target.value);
		value = (isNaN(parseInt(value)) ? value : parseInt(value)) + '';
		setValue(value, name);
		setMaskedValue(createMask(value));
	}

	return (
		<input className="money-input" onChange={handleChange} name={name} value={maskedValue} autoComplete="off"></input>
	)
}

export default MoneyInput